package songwritersnotebook.database

import kotlin.Long
import kotlin.String

public data class HarmonyChatMessageEntity(
  public val id: String,
  public val songId: String,
  public val userId: String,
  public val timestamp: Long,
  public val text: String,
  public val isUser: Long,
)
